import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { imagesTimeActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class ImagesTime extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newImageTime, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Tempo de leitura para as imagens'}
          classes={classes}
          newResource={newImageTime}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'imagens_minutos'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.imagesTime.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(imagesTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(imagesTimeActions.closeModal())
    },
    newImageTime: imageTime => {
      dispatch(imagesTimeActions.newFormImageTime(imageTime))
    },
    resetState: () => {
      dispatch(imagesTimeActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(ImagesTime))



// WEBPACK FOOTER //
// ./src/containers/ImagesTime/index.js